import Image from 'next/image'
import RAPTURES_LOGO from '../../../assets/icons/page/rapture-logo.svg'
import GOOGLE_ICON from '../../../assets/icons/auth/google.svg'
import APPLE_ICON from '../../../assets/icons/auth/apple.png'
import FACEBOOK_ICON from '../../../assets/icons/auth/facebook.svg'
import AppTextField from '../../core/app-text-field/AppTextField'
import { useLoginForm } from './LoginForm.hook'
import AppButton from '../../core/app-button/AppButton'
import { Icon } from '@iconify/react'
import AppLink from '../../core/app-link/AppLink'
import { Routes } from '../../../utils/Routes.utils'

export default function LoginForm() {
  const {
    email,
    password,
    googleSignInIntent,
    facebookSignInIntent,
    appleSignInIntent,
    onSubmit,
    onSkip,
    loading,
  } = useLoginForm()
  return (
    <section className={'py-10 px-5 bg-white min-h-screen'}>
      <section className={'flex items-center gap-5'}>
        <Image src={RAPTURES_LOGO} height={100} width={100} alt={'raptures'} />
        <h1 className={'text-[18px] font-bold'}>
          Login to read awesome comics
        </h1>
      </section>

      <form className={'grid gap-7 mt-10'} onSubmit={onSubmit}>
        <AppTextField
          name={'email'}
          value={email.value}
          type={'email'}
          error={'Enter a valid email address'}
          onFieldChange={email.onChange}
          required
          pattern={'\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})'}
          label={'Email Address'}
        />

        <AppTextField
          name={'password'}
          value={password.value}
          type={'password'}
          error={'Incorrect Password format'}
          onFieldChange={password.onChange}
          required
          pattern={'^(?=.*[a-z]).{8,20}$'}
          label={'Password'}
        />

        <AppButton square loading={loading}>
          Login
        </AppButton>
      </form>

      <section className={'grid mt-5 gap-12 w-full'}>
        <p
          className={
            'text-gray-500 text-sm font-medium flex items-center gap-2 max-w-max mx-auto'
          }
        >
          Forgot Password? <Icon icon="bi:arrow-right" />
        </p>

        <div className={'max-w-[150px] mx-auto w-full'}>
          <AppButton outlined size={'small'} expand onClick={onSkip}>
            Skip
          </AppButton>
        </div>
      </section>

      <section className={'mt-10'}>
        <p
          className={
            'text-gray-500 text-center border-b-[0.5px] border-gray-400 h-[11px]'
          }
        >
          <span className={'bg-white text-xs font-medium px-3'}>
            or Login with
          </span>
        </p>
      </section>

      <section className={'flex items-center max-w-max mx-auto mt-8 gap-5'}>
        <Image
          src={GOOGLE_ICON}
          alt="sign_in_with_google"
          width={42}
          height={42}
          onClick={googleSignInIntent}
          className={'cursor-pointer'}
        />
        <Image
          src={APPLE_ICON}
          alt="sign_in_with_facebook"
          width={40}
          height={40}
          className={'cursor-pointer'}
          onClick={appleSignInIntent}
        />
        <Image
          src={FACEBOOK_ICON}
          alt="sign_in_with_facebook"
          width={40}
          height={40}
          onClick={facebookSignInIntent}
          className={'cursor-pointer'}
        />
      </section>

      <section className={'grid mt-16 gap-4 w-full'}>
        <p
          className={
            'text-gray-500 text-sm font-medium flex items-center gap-2 max-w-max mx-auto'
          }
        >
          Don&apos;t have an account yet?
        </p>

        <AppLink
          href={Routes.SIGNUP}
          className={'max-w-[150px] mx-auto w-full'}
        >
          <AppButton theme={'dark'} expand>
            Sign up
          </AppButton>
        </AppLink>
      </section>

      <section className={'flex justify-between w-full text-gray-500 mt-20'}>
        <AppLink href={''} className={'text-xs'}>
          Terms
        </AppLink>
        <span className={'text-xs'}>
          Copyright &copy; {new Date().getFullYear()} Raptures
        </span>
        <AppLink href={''} className={'text-xs'}>
          Privacy
        </AppLink>
      </section>
    </section>
  )
}
